<template>
  <div
    v-show="contentList.length"
    class="table-of-content"
  >
    <h6>Оглавление</h6>

    <a
      v-for="(link, index) in contentList"
      :key="index"
      :href="`#h2-${index + 1}`"
      @click.prevent="toSection(`h2-${index + 1}`)"
      v-html="link"
    />
  </div>
</template>

<script>
const DEFAULT_SCROLL_TOP_OFFSET = 80;

export default {
  name: 'MaterialTableOfContents',
  props: {
    content: { type: Array, default: () => [] },
  },
  data: () => ({
    scrollTopOffset: DEFAULT_SCROLL_TOP_OFFSET,
  }),
  computed: {
    contentList() {
      const allContent = this.content.reduce((res, item) => `${res} ${item.payload}`, '');
      const allTitles = (allContent.match(/<h2.*?>(.*?)<\/h2>/gm) || []);
      return allTitles.map((item) => item.replace(/<\/?h2.*?>|&nbsp;/gm, ''));
    },
  },
  mounted() {
    this.setIdsForH2();
    this.calculateScrollTopOffset();
  },
  methods: {
    setIdsForH2() {
      document.querySelector('html').style['scroll-behavior'] = 'smooth';
      const materialH2Titles = document.querySelectorAll('.material-page h2');
      materialH2Titles.forEach((item, index) => {
        item.setAttribute('id', `h2-${index + 1}`);
      });
    },
    calculateScrollTopOffset() {
      const menuHeight = document.querySelector('header.header')?.offsetHeight ?? 0;
      this.scrollTopOffset = (menuHeight || DEFAULT_SCROLL_TOP_OFFSET) + 15;
    },
    toSection(elem) {
      const element = document.getElementById(elem);

      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          top: y - this.scrollTopOffset,
          behavior: 'smooth',
        });
      } else {
        // eslint-disable-next-line no-console
        console.error(`Элемент "${elem}" не существует`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../styles/main.scss';

.table-of-content {
  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 8);

  h6 {
    font-family: 'Onest', sans-serif;
    font-weight: 600;
    font-size: calc(var(--scale) * 24);
    line-height: 150%;
    color: #02120F;
  }

  a {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: calc(var(--scale) * 10);
    padding-left: calc(var(--scale) * 10);
    transition: 200ms;

    font-family: 'Onest', sans-serif;
    font-weight: 400;
    font-size: calc(var(--scale) * 16);
    line-height: 150%;
    color: #FF5319;

    &:before {
      content: '';
      flex-shrink: 0;
      display: block;
      margin-top: calc(var(--scale) * 10);
      width: calc(var(--scale) * 4);
      height: calc(var(--scale) * 4);
      border-radius: 50%;
      background-color: #FF5319;
      transition: 200ms;
    }

    :deep(*) {
      color: inherit !important;
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: 400;
      line-height: 150%;
    }

    @media (hover: hover) {
      &:hover {
        //color: #FF9C12;
        text-decoration: underline;

        &:before {
          //background-color: #FF9C12;
        }
      }
    }
  }

  :deep(br) {
    display: none;
  }
}

</style>
